var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBarsLoading(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 187,
    height: 140,
    viewBox: "0 0 187 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 139L187 139",
    stroke: "#E8E8E8",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 0L1.00001 139",
    stroke: "#E8E8E8",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 91C16 85.4772 20.4772 81 26 81H40C45.5228 81 50 85.4772 50 91V139H16V91Z",
    fill: "#E8E8E8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M73 62C73 56.4772 77.4772 52 83 52H98C103.523 52 108 56.4772 108 62V139H73V62Z",
    fill: "#E8E8E8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M131 48C131 42.4771 135.477 38 141 38H157C162.523 38 167 42.4772 167 48V139H131V48Z",
    fill: "#E8E8E8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarsLoading);
export default __webpack_public_path__ + "static/media/barsLoading.7713d39cc9a6e42ee42fbbf44a593905.svg";
export { ForwardRef as ReactComponent };